import { render, staticRenderFns } from "./desensitization.vue?vue&type=template&id=1702c190&scoped=true&"
import script from "./desensitization.vue?vue&type=script&lang=js&"
export * from "./desensitization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1702c190",
  null
  
)

export default component.exports